import React from "react";

function formatDate(dateString) {
  if (!dateString) return "—";
  const d = new Date(dateString);
  return d.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

const ExpenseViewLayer = ({ data=[] }) => {

  return (
    <div className="card basic-data-table">
      <div className="card-header d-flex justify-content-between">
        <h5 className="card-title mb-0">Expense Details</h5>
        <button className="btn btn-secondary" onClick={() => window.history.back()}>
          Back
        </button>
      </div>

      <div className="card-body">
        <div className="row">

          {/* Expense Title */}
          <div className="col-md-6 mb-20">
            <label className="form-label fw-semibold text-primary-light text-sm mb-8">
              Expense Title
            </label>
            <p>{data.expense_title || "—"}</p>
          </div>

          {/* Amount */}
          <div className="col-md-6 mb-20">
            <label className="form-label fw-semibold text-primary-light text-sm mb-8">
              Amount
            </label>
            <p>Rs. {Number(data.expense_amount || 0).toLocaleString()}</p>
          </div>

          {/* Date */}
          <div className="col-md-6 mb-20">
            <label className="form-label fw-semibold text-primary-light text-sm mb-8">
              Expense Date
            </label>
            <p>{formatDate(data.expense_date)}</p>
          </div>

          {/* Category */}
          <div className="col-md-6 mb-20">
            <label className="form-label fw-semibold text-primary-light text-sm mb-8">
              Category
            </label>
            <p>{data.ExpenseCategory?.title || "—"}</p>
          </div>

          {/* Reference */}
          <div className="col-md-6 mb-20">
            <label className="form-label fw-semibold text-primary-light text-sm mb-8">
              Reference Type
            </label>
            <p>{data.reference_type || "—"}</p>
          </div>

          <div className="col-md-6 mb-20">
            <label className="form-label fw-semibold text-primary-light text-sm mb-8">
              Reference ID
            </label>
            <p>{data.reference_id || "—"}</p>
          </div>

          {/* Notes */}
          <div className="col-md-12 mb-20">
            <label className="form-label fw-semibold text-primary-light text-sm mb-8">
              Notes
            </label>
            {data.notes ? (
              <div
                className="p-2 border rounded"
                dangerouslySetInnerHTML={{ __html: data.notes }}
              />
            ) : (
              <p>—</p>
            )}
          </div>

        </div>
      </div>
    </div>
  );
};

export default ExpenseViewLayer;
